import { Util } from '@/modules/util'
import { Request } from '@/classes/Request.ts'

export interface FormSubmission {
  formSubmissionId: string
  formSubmissionDate: string
  familyUserId: number
  contractRevisionId?: number
  contractName?: string
  forms?: any
  menuItemId?: number
  studentAccountId?: number
  formType?: string
}

export enum FormType {
  Contract = 'contract',
  Other = 'other'
}

export const getFormSubmissions = async (): Promise<FormSubmission[]> => {
  const response = await new Request().get('/ajax/forms')
  return Util.Obj.keysToCamel(response.data.forms) as FormSubmission[]
}
